import { zodResolver } from '@hookform/resolvers/zod';
import { createFileRoute, useRouter } from '@tanstack/react-router';
import { Button } from 'components/Button';
import { useState } from 'react';
import { Code } from 'components/Code';
import { FormProvider, useForm } from 'react-hook-form';
import { NewUserForm } from 'forms/UserForm';
import { emitMessage } from 'engine/api';
import { toast } from 'sonner';
import { CheckCheck, X } from 'lucide-react';
import { NewUserRecordSchema, type NewUserRecord } from 'shared/modelTypes/user';

export const Route = createFileRoute('/dashboard/users/new')({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div>
			<UserNewForm />
		</div>
	);
}

function UserNewForm() {
	const router = useRouter();

	const methods = useForm<NewUserRecord>({
		resolver: zodResolver(NewUserRecordSchema),
		// defaultValues: OptionalUserRecordSchema.parse({}),
	});

	const err = methods.formState.errors;

	const [result, setResult] = useState<NewUserRecord>();

	const onSubmit = async (data: NewUserRecord) => {
		const r = await emitMessage({
			kind: 'register',
			firstName: data.firstName,
			lastName: data.lastName,
			role: data.role ?? 'user',
			email: data.email,
			password: data.password,
		});

		console.log('register result:', r);
		if (r.success) {
			toast('Registered!', { icon: <CheckCheck /> });
			router.navigate({ to: '/login' });
		} else {
			toast('Could not register: ' + (r.msg ?? ''), { icon: <X /> });
		}

		setResult(data);
	};

	console.log(err);
	return (
		<FormProvider {...methods}>
			<form className="flex flex-col gap-3" onSubmit={methods.handleSubmit(onSubmit)}>
				<NewUserForm label="New User" />
				<Button type="submit">Submit</Button>
			</form>
			{result && (
				<Code block className="mt-4">
					{JSON.stringify(result, null, 2)}
				</Code>
			)}
		</FormProvider>
	);
}
